import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import { PopupInterface } from 'common/types/entities/popup-interface'
import { closePopup, showPopup } from 'publisher/actionsManagement'
import { useManagement, usePage } from 'publisher/store'
import managementSelectors from 'publisher/store/management/managementSelectors'
import pageSelectors from 'publisher/store/page/pageSelectors'
import { closeCookieExists, setCloseCookie } from 'publisher/utils/cookie'
import { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

export const OnExitPopup = () => {
  const popup = usePage(pageSelectors.getFirstOnExitPopup) as
    | PopupInterface
    | OldEntityInterface
  const triggeredPopupId = useManagement(managementSelectors.getActivePopupId)
  const pageId = usePage(pageSelectors.getPageId)
  const [wasOpened, setWasOpened] = useState(false)
  const dispatch = useDispatch()

  const notEqualsTriggeredPopup = popup?.id !== triggeredPopupId

  const popupClosedDays =
    popup?.type === EntityTypeEnum.Popup
      ? popup.closedDays
      : popup?.options?.closedDays

  const onLeaveHandler = useCallback(
    (event: MouseEvent) => {
      if (!popup || closeCookieExists(pageId, popup.id)) return

      if (
        event.clientY < 50 &&
        event.relatedTarget == null &&
        (event.target as HTMLElement).nodeName.toLowerCase() !== 'select'
      ) {
        dispatch(showPopup(popup?.id))
        setWasOpened(true)
        document.removeEventListener('mouseout', onLeaveHandler)
      }
    },
    [dispatch, pageId, popup],
  )

  useEffect(() => {
    if (popup && !closeCookieExists(pageId, popup.id)) {
      document.addEventListener('mouseout', onLeaveHandler)
      return () => document.removeEventListener('mouseout', onLeaveHandler)
    }
  }, [onLeaveHandler, pageId, popup])

  const handleClose = useCallback(() => {
    if (!popup?.id) return

    setCloseCookie(pageId, popup.id, popupClosedDays)
    dispatch(closePopup)
  }, [pageId, popup, popupClosedDays, dispatch])

  useEffect(() => {
    if (wasOpened && notEqualsTriggeredPopup && popup) {
      handleClose()
    }
  }, [wasOpened, notEqualsTriggeredPopup, handleClose, popup])

  // I guess the popup will not be rendered, it renders in TriggeredPopup component
  return null
}
